/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { BaseContentController } from './base-content-controller';

/**
 * @import { ContentController } from '.'
 */

/**
 * TODO: možná by se hodil nějaký piktogram, že není žádný obsah
 * @implements {ContentController}
 */
export class EmptyContentController extends BaseContentController {
  /** @type {ContentController['preload']} */
  async preload() {}

  /** @type {ContentController['restart']} */
  async restart() {}

  /** @type {ContentController['start']} */
  async start(offsetMs) {}

  /** @type {ContentController['stop']} */
  async stop() {}
}
